import React from 'react';

interface BrandLogoProps {
  className: string;
  loading?: 'eager' | 'lazy';
  ariaHidden?: boolean;
}

/**
 * The header-sized brand mark (WebP with a PNG fallback), shared by Header
 * and the loading skeleton. `<picture>` defaults to display:inline with no
 * intrinsic box, so it must be sized explicitly — otherwise the percentage
 * width/height + object-cover on the <img> have nothing to resolve against
 * and the logo renders at its raw 160x160 box instead of filling/cropping
 * into its circular container. `rounded-[inherit]` matters too: callers like
 * .samadhi-loader__logo use `border-radius: inherit` to pick up their
 * circular frame's radius, which only works if every element in between
 * also inherits it — border-radius doesn't inherit past an intermediate
 * element that doesn't explicitly forward it, so <picture> needs it too.
 */
export const BrandLogo: React.FC<BrandLogoProps> = ({ className, loading, ariaHidden }) => (
  <picture className="block h-full w-full rounded-[inherit]">
    <source srcSet="/samadhi-vihara-logo-header.webp" type="image/webp" />
    <img
      src="/samadhi-vihara-logo-header.png"
      alt=""
      aria-hidden={ariaHidden ? 'true' : undefined}
      width="160"
      height="160"
      loading={loading}
      className={className}
    />
  </picture>
);
